import { Experiments } from '../adobe-target-server-side/types'
import { getActualUIRendered } from './ssr-experiments-store'

export type { UIExperience } from './ssr-experiments-store'

/**
 * Analytics-specific experiment metadata interface
 * Maps Adobe Target experiment data to analytics event format
 */
export interface ExperimentAnalyticsData {
  name: string
  experienceIdDescription: 'Control' | 'Variant' | string
  experienceId: number | string
  actualUIRendered?: string
  experienceIdAndUIMatched?: boolean
}

/**
 * Converts Adobe Target experienceId to human-readable label
 * @param experienceId - Adobe Target experience ID (0 = Control, 1+ = Variant)
 * @returns User-friendly label for analytics
 */
export const getExperienceDeliveredLabel = (
  experienceId: number,
): ExperimentAnalyticsData['experienceIdDescription'] =>
  experienceId === 0 ? 'Control' : 'Variant'

/**
 * Formats ALL experiments data for analytics tracking
 * @param experiments - Array of experiments from SSR experiments provider
 * @returns Array of formatted experiment data for analytics, or empty array if no experiments
 */
export const getAllExperimentsDataForAnalytics = (
  experiments: Experiments,
): ExperimentAnalyticsData[] =>
  experiments.map((experiment) => {
    const actualUI = getActualUIRendered(experiment.name)
    const experienceIdDescription = getExperienceDeliveredLabel(
      experiment.experienceId,
    )

    return {
      name: experiment.name,
      experienceIdDescription,
      experienceId: experiment.experienceId,
      ...(actualUI !== undefined && {
        actualUIRendered: actualUI,
        experienceIdAndUIMatched: actualUI === experienceIdDescription,
      }),
    }
  })
